module.exports = __webpack_public_path__ + "static/media/twitter.ce9f841c.svg";